import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { setupTestingRouter } from '@angular/router/testing';
import { BaseRate } from 'src/app/_models/baseRateItem';
import { GatePass } from 'src/app/_models/gate_pass';
import { AuthService } from 'src/app/_services/auth.service';
import { BillingService } from 'src/app/_services/billing.service';

@Component({
  selector: 'app-admin-edit-base-rate',
  templateUrl: './admin-edit-base-rate.component.html',
  styleUrls: ['./admin-edit-base-rate.component.css']
})
export class AdminEditBaseRateComponent implements OnInit {
  baseRateForm :FormGroup
  update_success=false
  loading=true
  baseRate:BaseRate=new BaseRate()

  gatePass  = new GatePass()
  constructor(private billingService:BillingService,private route:ActivatedRoute,
    private router:Router, private authService:AuthService) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      x=>{
        let id =+x['id']
        this.billingService.getBaseRate(id).subscribe(
          x2=>{
            this.baseRate=x2
            this.loading=false
            this.initForm(this.baseRate)
          }
        )
      }
    )
  }
  get f(){
    return this.baseRateForm.controls
  }
  initForm(baseRate:BaseRate){
    this.baseRateForm = new FormGroup({
      'week': new FormControl(baseRate.week, [Validators.required]),
      'month': new FormControl(baseRate.month, [Validators.required]),
      'year': new FormControl(baseRate.year, [Validators.required]),

    });

  }
  on_submit(){
    this.update_success= false

    let baseRateTwo = new BaseRate()
    baseRateTwo.id=this.baseRate.id
    baseRateTwo.week=this.baseRateForm.value.week
    baseRateTwo.month=this.baseRateForm.value.month
    baseRateTwo.year=this.baseRateForm.value.year




    this.billingService.updateBaseRate(baseRateTwo).subscribe(
      x=>{

        this.update_success=true
        this.router.navigate(['/admin/billing/index'])
      }
    )

  }

  loadGatePass(){
    this.authService.gatePass.subscribe(
      x=>{this.gatePass=x}
    )
  }
}
